import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: "#FF792E",
    },
    secondary: {
      // This is green.A700 as hex.
      main: "#181818",
      dark: "#BDBDBD",
    },
  },
});

export default theme;
